import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductLoginComponent } from './product-login/product-login.component';
import { EcaBrowserDetectorModule, EcaLoginModule } from '@drc-eca/eca-components-lib';
import { SharedModule } from '../shared/shared.module';
import { LoginRoutingModule } from './login-routing.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { EcaLoginBaseModule } from '@drc-eca/eca-components-lib';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    ProductLoginComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    EcaBrowserDetectorModule,
    EcaLoginModule,
    EcaLoginBaseModule,
    FlexLayoutModule,
    SharedModule,
    MatCardModule,
    MatIconModule
  ]
})
export class LoginModule { }
